import React from 'react';
import {connect} from 'react-redux';
import propTypes from 'prop-types';
import lang from '../../constants/Languages.js';
import {Link} from 'react-router-dom';
// import { Player } from 'video-react';

// import arrow from '../../assets/icons/arrow-circle-empty-medium.svg';
import poster from '../../assets/icons/video-poster.png';
import dots from '../../assets/icons/video-dots.png';

const MainPagePos = ({ clang, data }) => {
    return (
        <article className="main-pos">
            <div className="main-pos__container">
                <div className="main-pos--left">
                    <a className="main-pos__header" href="https://open.icm.edu.pl/collections/ccb4eb71-256b-4659-9d56-4cfdd34bd70c" target="_blank" dangerouslySetInnerHTML={{__html: data.section_pbl_possibilities_title}}></a>
                    <div className="main-pos__video-container">
                        <img src={dots} alt="" className="main-pos__video-dots"/>
                        <div className="video-react-fluid">
                            <img src={poster} alt={lang[clang].alt.video_poster} className="main-pos__video-container video-react.video-react-fluid video-react-video video-react-poster"/>
                            <div className="video-react-poster" style={{backgroundImage: "url(" + poster + ")"}}></div>
                        </div>
                        {/*
                        <Player
                          playsInline
                          poster={poster}
                          src={data.section_pbl_possibilities_video}
                        />
                        */}

                    </div>
                   <a href="https://open.icm.edu.pl/collections/ccb4eb71-256b-4659-9d56-4cfdd34bd70c" title={lang[clang].title.possibilities_btn} className="main-pos__all-button" target="_blank">
                        {lang[clang].main_page.possibilities_btn}
                        <span className="main-pos__all-button__img external-link-arrow"></span>
                    </a>
                </div>
                <div className="main-pos--right">
                    <Link className="main-pos__header" to={`/about/what-is`} dangerouslySetInnerHTML={{__html: data.section_what_is_pbl_title}}></Link>
                    <div className="main-pos__desc" dangerouslySetInnerHTML={{__html: data.section_what_is_pbl_desc}}></div>
                    <Link to={`/about`} title={lang[clang].main_page.more_pbl} className="main-pos__all-button">
                        {lang[clang].main_page.more_pbl}
                        <span className="main-pos__all-button__img"></span>
                    </Link>
                </div>
            </div>
        </article>
    );
};

MainPagePos.propTypes = {
    clang: propTypes.string.isRequired
};

const mapStateToProps = state => ({
    clang: state.language.currentLanguage
});

export default connect(mapStateToProps)(MainPagePos);



// WEBPACK FOOTER //
// ./src/components/main-page/MainPagePos.js